/**
 * Disable AJAX cart drawer — keep shoppers on the page; drawer hidden via CSS in theme.liquid.
 */
(function () {
  function killDrawerState() {
    document.querySelectorAll('cart-drawer, cart-notification').forEach(function (el) {
      el.classList.remove('active', 'animate');
    });
    document.body.classList.remove('overflow-hidden');
  }

  function suppressDrawer(el) {
    if (!el || el.__ciwDrawerSuppressed) return;
    el.__ciwDrawerSuppressed = true;
    killDrawerState();

    new MutationObserver(function () {
      if (el.classList.contains('active') || el.classList.contains('animate')) {
        killDrawerState();
      }
    }).observe(el, { attributes: true, attributeFilter: ['class'] });
  }

  function bootDrawerGuards() {
    document.querySelectorAll('cart-drawer, cart-notification').forEach(suppressDrawer);
    if (window.__ciwDrawerGuardObserver) return;
    window.__ciwDrawerGuardObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && (node.matches('cart-drawer') || node.matches('cart-notification'))) {
            suppressDrawer(node);
          }
          if (node.querySelectorAll) {
            node.querySelectorAll('cart-drawer, cart-notification').forEach(suppressDrawer);
          }
        });
      });
    });
    window.__ciwDrawerGuardObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootDrawerGuards);
  } else {
    bootDrawerGuards();
  }

  window.setInterval(killDrawerState, 250);
})();
